import { useState } from 'react';

import { useServerClient, configuration as _configuration } from '../useServerClient';
import { useServerParams } from '../useServerParams';

export const configuration = _configuration

export const repositoryTypes = {
    container: "container",
    package: "package"
}

export const targetTypes = {
    container: "container",
    package: "package"
}

export function useRepositoryItems({ 
    repositoryType: _repositoryType, 
    targetType: _targetType
}) {

    const [repositoryType, setRepositoryType] = useState(_repositoryType);
    const [targetType, setTargetType] = useState(_targetType)

    const { makeCall, serverClient, getError } = useServerClient();
    const { getListsUrl, getUrlWithDataTypes, _operatorDef: filterOperatorTypes } = useServerParams();

    const [isLoading, setIsLoading] = useState(false)

    const endpoint = "repositories/items";
    // const endpoint2 = "repository";

    const list = async (props) => {

        setIsLoading(true);

        // option for configuration
        let configuration = props?.configuration

        try {

            let { repositoryType: overrideRepositoryType } = props

            let url = getListsUrl(`${endpoint}/${repositoryType}`, props)

            if (overrideRepositoryType) {
                url = getListsUrl(`${endpoint}/${overrideRepositoryType}`, props)
            }

            const response = await makeCall({
                url,
                method: "GET",
                payload: {},
                configuration
            });

            setIsLoading(false);

            return response;

        } catch (error) {

            // setIsLoading(false);
            // throw error;
            if (!serverClient.isCancel(error)) {
                setIsLoading(false);
                throw error;
            } else {
                setIsLoading(true);
            }

        }

        return true

    }

    return {
        isLoading,
        filterOperatorTypes,
        list,
        // get,
        // create,
        // update,
        // remove
    }
}